import React, { useState } from 'react';
import Header from '../../../component/layout/Header';
import Footer from '../../../component/layout/Footer';
import Page from '../../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../../style/color';

import { 
    Row, 
    Col, 
    Card, 
    CardBody, 
    CardHeader, 
    Input, 
    Label, 
    Button,
    InputGroup,
    InputGroupText,
    Badge,
    Spinner,
    Alert
} from 'reactstrap';

import { 
    FaPlusCircle, 
    FaEye, 
    FaFilePdf, 
    FaSearch,
    FaDownload,
    FaCalendarAlt,
    FaRupeeSign,
    FaShoppingCart,
    FaFileInvoiceDollar,
    FaFilter
} from 'react-icons/fa';
import InputPaymentScreen from '../../../component/utility/setting/InputPaymentScreen';

const PaymentScreen = () => {
    const [mode, setMode] = useState(1);
    const [loading, setLoading] = useState(false);
    const [frDate, setFrDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [tableData, setTableData] = useState([]);

    const get_sale_purchase_list = () => {
        setLoading(true);
        
        // Simulate API call delay
        setTimeout(() => {
            let list = [
                {
                    sl: 1,
                    trans_id: "SH1001",
                    trans_type: "Sale",
                    date: "04-02-2023",
                    amt: 1370.00,
                    amtDisplay: <div className="fw-bold text-success">&#8377; 1370.00</div>,
                    invoice: <FaFilePdf className='cursor-pointer text-danger' size={18} title="Download Invoice" />,
                    action: <Button color="info" size="sm" outline className="d-flex align-items-center gap-1">
                        <FaEye size={12} /> View
                    </Button>
                },
                {
                    sl: 2,
                    trans_id: "SH1002",
                    trans_type: "Sale",
                    date: "03-02-2023",
                    amt: 2370.00,
                    amtDisplay: <div className="fw-bold text-success">&#8377; 2370.00</div>,
                    invoice: <FaFilePdf className='cursor-pointer text-danger' size={18} title="Download Invoice" />,
                    action: <Button color="info" size="sm" outline className="d-flex align-items-center gap-1">
                        <FaEye size={12} /> View
                    </Button>
                },
                {
                    sl: 3,
                    trans_id: "PH1002",
                    trans_type: "Purchase",
                    date: "03-02-2023",
                    amt: 870.00,
                    amtDisplay: <div className="fw-bold text-primary">&#8377; 870.00</div>,
                    invoice: <FaFilePdf className='cursor-pointer text-danger' size={18} title="Download Invoice" />,
                    action: <Button color="info" size="sm" outline className="d-flex align-items-center gap-1">
                        <FaEye size={12} /> View
                    </Button>
                },
                {
                    sl: 4,
                    trans_id: "SH1006",
                    trans_type: "Purchase",
                    date: "03-02-2023",
                    amt: 1070.00,
                    amtDisplay: <div className="fw-bold text-primary">&#8377; 1070.00</div>,
                    invoice: <FaFilePdf className='cursor-pointer text-danger' size={18} title="Download Invoice" />,
                    action: <Button color="info" size="sm" outline className="d-flex align-items-center gap-1">
                        <FaEye size={12} /> View
                    </Button>
                },
                {
                    sl: 5,
                    trans_id: "SH1010",
                    trans_type: "Sale",
                    date: "02-02-2023",
                    amt: 3250.00,
                    amtDisplay: <div className="fw-bold text-success">&#8377; 3250.00</div>,
                    invoice: <FaFilePdf className='cursor-pointer text-danger' size={18} title="Download Invoice" />,
                    action: <Button color="info" size="sm" outline className="d-flex align-items-center gap-1">
                        <FaEye size={12} /> View
                    </Button>
                },
                {
                    sl: 6,
                    trans_id: "PH1008",
                    trans_type: "Purchase",
                    date: "01-02-2023",
                    amt: 1580.00,
                    amtDisplay: <div className="fw-bold text-primary">&#8377; 1580.00</div>,
                    invoice: <FaFilePdf className='cursor-pointer text-danger' size={18} title="Download Invoice" />,
                    action: <Button color="info" size="sm" outline className="d-flex align-items-center gap-1">
                        <FaEye size={12} /> View
                    </Button>
                }
            ];
            setTableData(list);
            setFilteredData(list);
            setLoading(false);
        }, 1000);
    };

    // Search functionality
    const handleSearch = (value) => {
        setSearchTerm(value);
        if (value === '') {
            setFilteredData(tableData);
        } else {
            const filtered = tableData.filter(item =>
                item.trans_id.toLowerCase().includes(value.toLowerCase()) ||
                item.trans_type.toLowerCase().includes(value.toLowerCase()) ||
                item.date.includes(value)
            );
            setFilteredData(filtered);
        }
    };

    // Calculate statistics
    const totalSales = tableData.filter(item => item.trans_type === 'Sale').reduce((sum, item) => sum + item.amt, 0);
    const totalPurchases = tableData.filter(item => item.trans_type === 'Purchase').reduce((sum, item) => sum + item.amt, 0);
    const salesCount = tableData.filter(item => item.trans_type === 'Sale').length;
    const purchasesCount = tableData.filter(item => item.trans_type === 'Purchase').length;

    const columns = [
        {
            name: '#',
            selector: row => row.sl,
            sortable: true,
            width: '70px',
            center: true
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaFileInvoiceDollar size={12} />
                    Transaction ID
                </div>
            ),
            selector: row => row.trans_id,
            sortable: true,
            cell: row => (
                <Badge 
                    color={row.trans_type === 'Sale' ? 'success' : 'primary'} 
                    className="font-monospace"
                    pill
                >
                    {row.trans_id}
                </Badge>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaShoppingCart size={12} />
                    Transaction Type
                </div>
            ),
            selector: row => row.trans_type,
            sortable: true,
            cell: row => (
                <Badge 
                    color={row.trans_type === 'Sale' ? 'success' : 'primary'} 
                    outline
                >
                    {row.trans_type}
                </Badge>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaCalendarAlt size={12} />
                    Date
                </div>
            ),
            selector: row => row.date,
            sortable: true,
            width: '140px'
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaRupeeSign size={12} />
                    Amount
                </div>
            ),
            selector: row => row.amt,
            sortable: true,
            cell: row => row.amtDisplay,
            right: true
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaFilePdf size={12} />
                    Invoice
                </div>
            ),
            selector: row => row.invoice,
            sortable: false,
            center: true,
            width: '100px'
        },
        {
            name: 'Actions',
            selector: row => row.action,
            sortable: false,
            center: true,
            width: '120px'
        }
    ];

    return (
        <>
            <Header />
            <Page title='Payment Management' breadcrumbs='Home / Payment Management'>
                {mode === 1 && (
                    <Row className="p-3">
                        <Col xs={12}>
                            {/* Action Bar */}
                            <Card className='mb-4 border-0 shadow-sm'>
                                <CardBody className="py-3">
                                    <Row className="align-items-center">
                                        <Col md={8}>
                                            <div className="d-flex gap-2 flex-wrap">
                                                <Button
                                                    color='primary'
                                                    size="sm"
                                                    onClick={get_sale_purchase_list}
                                                    disabled={loading}
                                                    className="d-flex align-items-center gap-2"
                                                >
                                                    {loading ? (
                                                        <Spinner size="sm" />
                                                    ) : (
                                                        <FaSearch size={14} />
                                                    )}
                                                    {loading ? 'Loading...' : 'Load Transactions'}
                                                </Button>
                                                <Button
                                                    color='success'
                                                    size="sm"
                                                    onClick={() => setMode(4)}
                                                    className="d-flex align-items-center gap-2"
                                                >
                                                    <FaPlusCircle size={14} />
                                                    Add Transaction
                                                </Button>
                                                <Button
                                                    color='secondary'
                                                    size="sm"
                                                    disabled={tableData.length === 0}
                                                    className="d-flex align-items-center gap-2 text-white"
                                                >
                                                    <FaDownload size={14} />
                                                    Export Data
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <InputGroup size="sm">
                                                <InputGroupText className="bg-light border-end-0">
                                                    <FaSearch className="text-muted" />
                                                </InputGroupText>
                                                <Input
                                                    type="search"
                                                    placeholder='Search transactions...'
                                                    value={searchTerm}
                                                    onChange={(e) => handleSearch(e.target.value)}
                                                    className="border-start-0"
                                                />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                            {/* Statistics Cards */}
                            {tableData.length > 0 && (
                                <Row className="mb-4">
                                    <Col md={3}>
                                        <Card className="border-0 bg-primary text-white">
                                            <CardBody className="text-center py-3">
                                                <FaFileInvoiceDollar size={24} className="mb-2" />
                                                <h5 className="mb-0">{tableData.length}</h5>
                                                <small>Total Transactions</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-success text-white">
                                            <CardBody className="text-center py-3">
                                                <FaRupeeSign size={24} className="mb-2" />
                                                <h5 className="mb-0">₹{totalSales.toLocaleString()}</h5>
                                                <small>Total Sales ({salesCount})</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-info text-white">
                                            <CardBody className="text-center py-3">
                                                <FaShoppingCart size={24} className="mb-2" />
                                                <h5 className="mb-0">₹{totalPurchases.toLocaleString()}</h5>
                                                <small>Total Purchases ({purchasesCount})</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-warning text-white">
                                            <CardBody className="text-center py-3">
                                                <FaRupeeSign size={24} className="mb-2" />
                                                <h5 className="mb-0">₹{(totalSales - totalPurchases).toLocaleString()}</h5>
                                                <small>Net Balance</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            )}

                            {/* Date Filter Section */}
                            {tableData.length > 0 && (
                                <Card className="mb-4 border-0 shadow-sm">
                                    <CardBody className="py-3">
                                        <Row className="align-items-center">
                                            <Col md={2}>
                                                <div className="d-flex align-items-center gap-2">
                                                    <FaFilter className="text-muted" />
                                                    <Label className="mb-0 fw-bold">Filter by Date:</Label>
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div>
                                                    <Label size="sm" className="text-muted">From Date</Label>
                                                    <Input
                                                        type="date"
                                                        size="sm"
                                                        value={frDate}
                                                        onChange={(e) => setFrDate(e.target.value)}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div>
                                                    <Label size="sm" className="text-muted">To Date</Label>
                                                    <Input
                                                        type="date"
                                                        size="sm"
                                                        value={toDate}
                                                        onChange={(e) => setToDate(e.target.value)}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={2}>
                                                <Button 
                                                    color="outline-primary" 
                                                    size="sm" 
                                                    className="mt-3 d-flex align-items-center gap-1"
                                                >
                                                    <FaSearch size={12} />
                                                    Apply Filter
                                                </Button>
                                            </Col>
                                            <Col md={2}>
                                                <Button 
                                                    color="outline-secondary" 
                                                    size="sm" 
                                                    className="mt-3"
                                                    onClick={() => {
                                                        setFrDate('');
                                                        setToDate('');
                                                    }}
                                                >
                                                    Clear
                                                </Button>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            )}

                            {/* Main Data Table */}
                            <Card className='border-0 shadow-sm'>
                                <CardHeader className="bg-white border-bottom">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h5 className="mb-0">Transaction Records</h5>
                                            <small className='text-muted'>
                                                {filteredData.length > 0 ?
                                                    `Showing ${filteredData.length} of ${tableData.length} transactions` :
                                                    'No transactions found'
                                                }
                                            </small>
                                        </div>
                                        {searchTerm && (
                                            <Badge color="secondary" className="ms-2">
                                                Filtered: {filteredData.length}
                                            </Badge>
                                        )}
                                    </div>
                                </CardHeader>
                                <CardBody className="p-0">
                                    {tableData.length === 0 && !loading ? (
                                        <Alert color="info" className="m-3 text-center">
                                            <FaFileInvoiceDollar size={48} className="mb-3 text-muted" />
                                            <p className="mb-2">No transactions loaded yet</p>
                                            <small>Click "Load Transactions" to fetch the latest data</small>
                                        </Alert>
                                    ) : (
                                        <DataTable
                                            title=""
                                            customStyles={custTableStyles}
                                            columns={columns}
                                            data={filteredData}
                                            highlightOnHover
                                            responsive
                                            pagination
                                            paginationPerPage={10}
                                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                            progressPending={loading}
                                            progressComponent={
                                                <div className="d-flex flex-column align-items-center justify-content-center py-5">
                                                    <Spinner color="primary" />
                                                    <p className="mt-2 text-muted">Loading transactions...</p>
                                                </div>
                                            }
                                            noDataComponent={
                                                <div className="text-center py-5">
                                                    <FaSearch size={48} className="text-muted mb-3" />
                                                    <p className="text-muted">No transactions match your search criteria</p>
                                                </div>
                                            }
                                        />
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )}

                {mode === 4 && (
                    <Row className="p-3">
                        <Col xs={12}>
                            <InputPaymentScreen back={() => setMode(1)} />
                        </Col>
                    </Row>
                )}
            </Page>
            <Footer />
        </>
    );
};

export default PaymentScreen;